/** Edit details (f15.1): title and description only. Versions are immutable. */

import { useState } from 'react';
import { Check } from 'lucide-react';

import type { ArtifactDetail } from '@/api/client';
import { generalMessage, problemFor } from '@/api/fieldErrors';
import { useUpdateArtifact } from '@/api/queries';
import { DialogField, Modal } from '@/routes/reference-data/Modal';

export function EditArtifactDialog({ artifact, onClose }: { artifact: ArtifactDetail; onClose: () => void }) {
  const update = useUpdateArtifact(artifact);
  const [title, setTitle] = useState(artifact.title);
  const [description, setDescription] = useState(artifact.description ?? '');
  const failure = update.error;

  return (
    <Modal
      title="Edit details"
      subtitle="Stored versions are never edited"
      onClose={onClose}
      onSubmit={() => update.mutate({ title, description }, { onSuccess: onClose })}
      busy={update.isPending}
      submitDisabled={title.trim() === ''}
      submitLabel="Save details"
      submitIcon={<Check aria-hidden="true" />}
      layout="plain"
      message={generalMessage(failure, 'title', 'description')}
    >
      <div className="stack-sm">
        <DialogField label="Title" htmlFor="edit-artifact-title" problem={problemFor(failure, 'title')}>
          <input
            id="edit-artifact-title"
            type="text"
            value={title}
            required
            maxLength={200}
            onChange={(event) => setTitle(event.target.value)}
          />
        </DialogField>
        <DialogField label="Description" htmlFor="edit-artifact-description" problem={problemFor(failure, 'description')}>
          <textarea
            id="edit-artifact-description"
            rows={4}
            maxLength={2000}
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </DialogField>
      </div>
    </Modal>
  );
}
